import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderOpen02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.579 10.484V7.442a1 1 0 0 0-1-1h-6.67a1 1 0 0 1-.707-.293L9.767 4.714a1 1 0 0 0-.708-.293H3.4a1 1 0 0 0-1 1V18.58a1 1 0 0 0 1 1h1.176a.855.855 0 0 0 .856-.855q0-.156.054-.3l2.734-7.29a1 1 0 0 1 .936-.65h11.057a1 1 0 0 1 .948 1.316l-2.365 7.095a1 1 0 0 1-.948.684H4.42"
    />
  </svg>
);
export default SvgFolderOpen02;
